import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import externalExamGroupsStore from '../../../../../../../../stores/external-exam-groups-store';
import { UpdateExternalExamGroupExamRequest } from '../../../../../../../../api/types/external-exams/external-exam-group-crud';

export const updateExamInGroupOperation = async (
  groupId: number,
  examId: number,
  request: UpdateExternalExamGroupExamRequest,
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.updateExamInGroup(groupId, examId, request);
    if (res.data.ok) {
      await externalExamGroupsStore.fetchGroups();
      toast.success(`עדכון מבחן התבצע בהצלחה`);
      onSuccess();
    } else {
      toast.error(`עדכון מבחן נכשל, נסה שוב בעוד מספר רגעים...`);
    }
    setLoading(false);
  } catch (e) {
    toast.error('עדכון מבחן נכשל, נסה שוב בעוד מספר רגעים...');
    console.error(`updateExamInGroupOperation failed: ${e}`);
    setLoading(false);
  }
};
